import type { CustomRequestConfigMeta } from './maxios'

/**
 * maxios 의 meta.useAbortController 와 같은 규칙(같은 키의 앞선 요청을 버린다)을 domain 요청 함수에 쓴다.
 * domain 요청은 maxios 의 meta 를 거치지 않으므로 signal 로 넘긴다.
 */
export const createLatestRequestSignal = (defaultKey: string) => {
  const controllers = new Map<string, AbortController>()
  return (meta?: CustomRequestConfigMeta) => {
    if (!meta?.useAbortController) return undefined
    const key = meta.customUniqueKey || defaultKey
    controllers.get(key)?.abort()
    const controller = new AbortController()
    controllers.set(key, controller)
    return controller.signal
  }
}
